import { LocaleCode, TerminologyConcept } from './types';
import { nowIso } from './hash';

export function findConceptsInText(text: string, concepts: TerminologyConcept[]): TerminologyConcept[] {
  const lower = text.toLowerCase();
  return concepts.filter((concept) => lower.includes(concept.canonicalEnglish.toLowerCase()));
}

export function approvedTerm(concept: TerminologyConcept, locale: LocaleCode): string | undefined {
  return concept.terms.find((term) => term.locale === locale)?.approved;
}

export function forbiddenTerms(concept: TerminologyConcept, locale: LocaleCode): string[] {
  return concept.terms.find((term) => term.locale === locale)?.forbidden ?? [];
}

export function updateApprovedTerm(
  concepts: TerminologyConcept[],
  conceptId: string,
  locale: LocaleCode,
  value: string,
): TerminologyConcept[] {
  return concepts.map((concept) => {
    if (concept.conceptId !== conceptId) return concept;
    return {
      ...concept,
      version: concept.version + 1,
      updatedAt: nowIso(),
      terms: concept.terms.map((term) => (term.locale === locale ? { ...term, approved: value } : term)),
    };
  });
}
